import { render, staticRenderFns } from "./MyInfoRegistrationForm.vue?vue&type=template&id=e705fb74&"
import script from "./MyInfoRegistrationForm.vue?vue&type=script&lang=js&"
export * from "./MyInfoRegistrationForm.vue?vue&type=script&lang=js&"
import style0 from "./MyInfoRegistrationForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports